import { Component, inject } from '@angular/core';
import { StopTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  StopTypeCreateDto,
  StopTypeDto,
  StopTypeExcelDownloadDto,
  StopTypeUpdateDto,
} from '../proxy/controlling/dtos/stop-type';
import { STOPTYPE_CONFIG, STOPTYPE_FIELDS } from './stop-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-stop-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, StopTypeService, ConfirmationService],
  templateUrl: './stop-type.html',
  styleUrl: './stop-type.scss',
})
export class StopType extends BaseCrudComponent<
  StopTypeDto,
  StopTypeCreateDto,
  StopTypeUpdateDto,
  StopTypeExcelDownloadDto
> {
  service = inject(StopTypeService);
  config = STOPTYPE_CONFIG;
  fields = STOPTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: StopTypeDto): StopTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'StopType';
  }
}
